<tr class="animate-pulse">
  {#each { length: 7 }}
    <td><div class="placeholder w-full h-5"></div></td>
  {/each}
</tr>
